<template>
  <v-container id="project-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary :type="status" :statuses="bidStatuses" :title="title" :sub-header="subHeader" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardCancelledSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary'),
    },
    props: {
      bidStatuses: {
        type: Array,
        default: () => [14],
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_CANCELLED,
      title: 'Cancelled Project Summary',
      subHeader: 'Cancelled Projects',
    }),
  })
</script>

<style lang="sass">
  section#project-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
